import { AnyAction, Dispatch } from 'redux';
import { ApplicationList, AuthenticatedActionTypes, AuthenticatedState, ForbiddenFeature } from '../models/authenticated-model';
import { TcsmFeatures } from '../models/features-model';

const InitialState: AuthenticatedState = {
	clientGuid: '',
	accessToken: '',
	forbiddenFeatures: [],
	applicationList: [],
	benefitFacts: null,
};

const updateForbidden = (forbidden: ForbiddenFeature[], feature: ForbiddenFeature) => {
	return [...forbidden.filter(x => x.feature !== feature.feature), feature];
};

const removeForbidden = (forbidden: ForbiddenFeature[], feature: ForbiddenFeature) => {
	return [...forbidden.filter(x => x.feature !== feature.feature)];
};
export const authenticatedReducer = (state = InitialState, action: AnyAction): AuthenticatedState => {

	switch (action.type) {
		case AuthenticatedActionTypes.SET_ACCESS_TOKEN:
			return {
				...state,
				accessToken: action.payload,
			};
		case AuthenticatedActionTypes.SET_CLIENT_GUID:
			return {
				...state,
				clientGuid: action.payload,
			};
		case AuthenticatedActionTypes.ADD_FORBIDDEN_FEATURE:
			return {
				...state,
				forbiddenFeatures: updateForbidden(state.forbiddenFeatures, action.payload),
			};
		case AuthenticatedActionTypes.CLEAR_FORBIDDEN_FEATURES:
			return {
				...state,
				forbiddenFeatures: [],
			};
		case AuthenticatedActionTypes.REMOVE_FORBIDDEN_FEATURE:
			return {
				...state,
				forbiddenFeatures: removeForbidden(state.forbiddenFeatures, action.payload),
			};

		case AuthenticatedActionTypes.SET_APPLICATION_LIST:
			return {
				...state,
				applicationList: action.payload,
			};

		case AuthenticatedActionTypes.SET_ROLES:
			return {
				...state,
				roles: action.payload,
			};

		case AuthenticatedActionTypes.SET_BENEFIT_FACTS:
			return {
				...state,
				benefitFacts: action.payload,
			};

		case AuthenticatedActionTypes.SET_ROLE_OBJECT:
			return {
				...state,
				roleObject: action.payload,
			};
		default: return state;
	}
};

export const addForbiddenFeature = (feature: ForbiddenFeature) => {
	return {
		type: AuthenticatedActionTypes.ADD_FORBIDDEN_FEATURE,
		payload: feature,
	};
};

export const clearForbiddenFeatures = () => {
	return {
		type: AuthenticatedActionTypes.CLEAR_FORBIDDEN_FEATURES,
	};
};

export const setAccessToken = (accessToken: string): AnyAction => {
	return {
		type: AuthenticatedActionTypes.SET_ACCESS_TOKEN,
		payload: accessToken,
	};
};

export const removeForbiddenFeature = (feature: TcsmFeatures): AnyAction => {
	return {
		type: AuthenticatedActionTypes.REMOVE_FORBIDDEN_FEATURE,
		payload: feature,
	};
};

export const setClientGuid = (guid: string): AnyAction => {
	return {
		type: AuthenticatedActionTypes.SET_CLIENT_GUID,
		payload: guid,
	};
};


export const setApplicationList = (applicationList: ApplicationList[]): AnyAction => {
	return {
		type: AuthenticatedActionTypes.SET_APPLICATION_LIST,
		payload: applicationList,
	};
};

export const dispatchSetApplicationList = (response: any, dispatch: Dispatch<any>) => {
	dispatch(setApplicationList(response?.data));
};


export const setRoles = (roles: string[]): AnyAction => {
	return {
		type: AuthenticatedActionTypes.SET_ROLES,
		payload: roles,
	};
};


export const setBenefitFacts = (payload: string): AnyAction => {
	return {
		type: AuthenticatedActionTypes.SET_BENEFIT_FACTS,
		payload,
	};
};

export const setRoleObject = (roles: any): AnyAction => {
	return {
		type: AuthenticatedActionTypes.SET_ROLE_OBJECT,
		payload: roles,
	};
};

